import { render, staticRenderFns } from "./DefaultTmpl.vue?vue&type=template&id=d9e8cf58&scoped=true"
import script from "./DefaultTmpl.vue?vue&type=script&lang=js"
export * from "./DefaultTmpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9e8cf58",
  null
  
)

export default component.exports